import { render, staticRenderFns } from "./superuser-import-customer.vue?vue&type=template&id=cde36ef0&"
import script from "./superuser-import-customer.vue?vue&type=script&lang=js&"
export * from "./superuser-import-customer.vue?vue&type=script&lang=js&"
import style0 from "./superuser-import-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports